import type React from "react";
import { useState, useEffect } from "react";
import { Images } from "../utils/imageConstants";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../redux/slice/activeTabSlice";
import { useAppSelector } from "../redux/hooks";
import {
  selectSelectedLeagueId,
  selectSelectedLeagueName,
} from "../redux/slice/selectedLeagueSlice";
import { useLocation, useNavigate } from "react-router-dom";

const BreadCrumb: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = useAppSelector((s) => s.activeTab.value);
  const leagueName = useAppSelector(selectSelectedLeagueName);
  const selectedLeagueId = useAppSelector(selectSelectedLeagueId);
  const tournamentName = sessionStorage.getItem("tournamentName");

  // State to track tournament tab and force re-render
  const [tournamentTab, setTournamentTab] = useState<string>(() => {
    const isGalleryDetails = location.pathname.includes("/tournaments/tournaments-details/gallery-details");
    return sessionStorage.getItem("tournamentTab") || (isGalleryDetails ? "Gallery" : "Matches");
  });

  // Check if we're in tournament details page
  const isInTournamentDetails =
    location.pathname.includes("/tournaments/tournaments-details") ||
    location.pathname.includes("/tournamentDetails/");
  const isGalleryDetails = location.pathname.includes("/tournaments/tournaments-details/gallery-details");

  // Listen for storage changes to update tournament tab immediately
  useEffect(() => {
    const handleStorageChange = () => {
      const storedTab = sessionStorage.getItem("tournamentTab");
      if (storedTab) {
        setTournamentTab(storedTab);
      }
    };

    // Listen for custom event when tournament tab changes
    window.addEventListener("tournamentTabChanged", handleStorageChange);

    // Also check on location change
    const storedTab = sessionStorage.getItem("tournamentTab");
    if (storedTab) {
      setTournamentTab(storedTab);
    } else {
      setTournamentTab(isGalleryDetails ? "Gallery" : "Matches");
    }

    return () => {
      window.removeEventListener("tournamentTabChanged", handleStorageChange);
    };
  }, [location.pathname, isGalleryDetails]);

  // Tab name mapping for main tabs
  const getTabDisplayName = (tab: string | null): string => {
    if (!tab) return "";
    const tabMap: Record<string, string> = {
      home: "Home",
      tournaments: "Tournaments",
      matches: "Matches",
      teams: "Teams",
      gallery: "Gallery",
      about: "About",
      squads: "Squads",
      documents: "Documents",
      requests: "Requests",
      grounds: "Grounds",
    };
    return tabMap[tab] || tab.charAt(0).toUpperCase() + tab.slice(1).toLowerCase();
  };

  const displayTabName = getTabDisplayName(activeTab);

  /** League shell default view (completed matches / league home) — either legacy `home` or nav tab `leagues-home`. */
  const isLeagueShellLanding =
    activeTab === "home" || activeTab === "leagues-home";

  const handleLeaguesClick = () => {
    dispatch(setActiveTab("home"));
    navigate(selectedLeagueId ? `/my-leagues/${selectedLeagueId}` : "/leagues-home");
  };

  const handleTournamentsClick = () => {
    dispatch(setActiveTab("tournaments"));
    navigate(selectedLeagueId ? `/my-leagues/${selectedLeagueId}` : "/leagues-home");
  };

  return (
    <>
    </>
    // <div className="breadcrumb-container">
    //   {/* Home */}
    //   <span className="breadcrumb-item">Home</span>

    //   {/* › Leagues (leagueName) */}
    //   <span className="breadcrumb-separator">
    //     <img src={Images.breadcrumb_icon} alt="" aria-hidden />
    //   </span>
    //   <span
    //     className={`breadcrumb-item${!isLeagueShellLanding ? " clickable" : ""}`}
    //     onClick={!isLeagueShellLanding ? handleLeaguesClick : undefined}
    //   >
    //     Leagues{" "}
    //     <span className={isLeagueShellLanding ? "breadcrumb-item-active" : ""}>
    //       {leagueName ? `(${leagueName})` : ""}
    //     </span>
    //   </span>

    //   {/* › Tournaments (tournamentName)  — shown when inside tournament details */}
    //   {isInTournamentDetails && tournamentName && (
    //     <>
    //       <span className="breadcrumb-separator">
    //         <img src={Images.breadcrumb_icon} alt="" aria-hidden />
    //       </span>
    //       <span className="breadcrumb-item">
    //         Tournaments{" "}
    //         <span className="breadcrumb-item-active">
    //           {`(${tournamentName})`}
    //         </span>
    //       </span>
    //     </>
    //   )}

    //   {/* › ActiveTab — shown for non-tournament, non-home tabs */}
    //   {activeTab &&
    //     activeTab !== "home" &&
    //     activeTab !== "leagues-home" &&
    //     !isInTournamentDetails && (
    //       <>
    //         <span className="breadcrumb-separator">
    //           <img src={Images.breadcrumb_icon} alt="" aria-hidden />
    //         </span>
    //         <span className="breadcrumb-item-active">{displayTabName}</span>
    //       </>
    //     )}
    // </div>
  );
};

export default BreadCrumb;
